import React from 'react';
import './EmbedVideo.css';
import { Link } from 'react-router-dom';

const EmbedVideo = (props: any) => {
  const video = props.match.params.embed || '';
  return (
    <div className="section">
      <Link to="/videa" className="go-back">&larr; Zpět na seznam videí</Link>
      <div className="embed">
        <iframe title={video} src={`https://www.youtube.com/embed/${video}`} className="embed-video" />
      </div>
    </div>
  );
}

export default EmbedVideo;